import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { managementApiRef, ManagementClient } from './api';
import { rootRouteRef } from './routes';

export const managementPlugin = createPlugin({
  id: 'management',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: managementApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new ManagementClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const ManagementPage = managementPlugin.provide(
  createRoutableExtension({
    name: 'ManagementPage',
    component: () =>
      import('./components/ManagementPage').then(m => m.ManagementPage),
    mountPoint: rootRouteRef,
  }),
);
